import { render, staticRenderFns } from "./PaymentRecordFormNew.vue?vue&type=template&id=07960bd6&scoped=true"
import script from "./PaymentRecordFormNew.vue?vue&type=script&lang=ts"
export * from "./PaymentRecordFormNew.vue?vue&type=script&lang=ts"
import style0 from "./PaymentRecordFormNew.vue?vue&type=style&index=0&id=07960bd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07960bd6",
  null
  
)

export default component.exports